import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/cms/top-tours', request)
}

export {get}
